import BatchInfo from '../BatchInfo';
import {BatchInfo as BatchInfoType} from '@buncha/AboutShift/types';
import BatchListHeader from '../BatchListHeader';
import {Box} from '@buncha/components/core/view';
import {HomeScreens} from '@buncha/home/navigation/types';
import If from '@buncha/components/conditional/If';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {useGetLocale} from '@buncha/localization/hooks';

interface VanLocationIndo {
  batchInfo: BatchInfoType;
}

const VanLocation = (props: VanLocationIndo) => {
  const masterRun = props?.batchInfo.run?.masterRun;
  const {title} =
    useGetLocale(Modules.aboutShift, HomeScreens.AboutShift) ?? {};

  return (
    <If condition={props?.batchInfo.run?.masterRun}>
      <Box>
        <BatchListHeader headerTitle={title?.vanLoadLocation} />
        <BatchInfo run={masterRun} hideStoreInfo />
      </Box>
    </If>
  );
};

export default React.memo(VanLocation);
